import React from "react";
import { Link } from "react-router-dom";

// En-tête d'identité d'une fiche : retour, sur-titre, titre, pastilles,
// actions ; le corps (faits, encarts) est passé en enfants.
// `headingLevel` : "h1" en page, "h2" quand la fiche s'ouvre dans un panneau
// ou une modale d'une page qui a déjà son h1.
// `titleRef` : la page y ramène le focus (`.focus()`) quand l'action qui
// l'avait disparaît de l'en-tête (désactiver → réactiver) ; le titre est
// alors focalisable par script seulement (tabIndex -1).
const FicheHeader = ({
  back = null,
  backLabel = "Retour à la liste",
  eyebrow = null,
  title,
  pills = null,
  actions = null,
  headingLevel: Heading = "h1",
  titleRef = null,
  children,
}) => (
  <header className="fiche-header list-card">
    <div className="fiche-header__top">
      {back && (
        <Link to={back} className="fiche-header__back" aria-label={backLabel} title={backLabel}>
          <i className="fa fa-arrow-left" aria-hidden="true" />
        </Link>
      )}
      <div className="fiche-header__identity">
        {eyebrow && <div className="fiche-header__eyebrow">{eyebrow}</div>}
        <Heading className="fiche-header__title" ref={titleRef || undefined} tabIndex={titleRef ? -1 : undefined}>
          {title}
        </Heading>
        {pills && <div className="fiche-header__pills">{pills}</div>}
      </div>
      {actions && <div className="fiche-header__actions">{actions}</div>}
    </div>
    {children && <div className="fiche-header__body">{children}</div>}
  </header>
);

export default FicheHeader;
